import defaultImg from "../../assets/images/SD-default-image.png"
export const imageTypeList = [
  {
    name:'logo',
    label:"Business Logo",
    imagePath:defaultImg
  },
  {
    name:'shopFrontImage',
    label:"Shop Front Image",
    imagePath:defaultImg
  },
  {
    name:'shopInsideImage',
    label:"Shop Insider Image",
    imagePath:defaultImg
  },
  {
    name:'shopActImage',
    label:"Shop Act Image",
    imagePath:defaultImg
  },
  {
    name:'pancardImage',
    label:"Shop Card Image",
    imagePath:defaultImg
  },
  {
    name:'gstImage',
    label:"GST Image",
    imagePath:defaultImg
  }
]